import ProjectConfig from 'ProjectConfig';

const CONTENT_URL = new URL(ProjectConfig.CONTENT_URL);

const isTst = CONTENT_URL.hostname.includes('tst');

export const DEFAULT_LOGOS = {
  competition: isTst
    ? `${CONTENT_URL.origin}/assets/20260105_091147_136a46_default-competition-logo@3x.png`
    : `${CONTENT_URL.origin}/assets/20260105_121052_401ac2_default-competition-logo@3x.png`,

  participant: isTst
    ? `${CONTENT_URL.origin}/assets/20251231_080651_bff52a_default-team-logo@3x.png`
    : `${CONTENT_URL.origin}/assets/20260104_164108_f8770c_default-team-logo@3x.png`,
};

export const getCompetitionLogoUrl = competitionId =>
  `${CONTENT_URL.origin}/assets/competition/${competitionId}.png`;

export const getParticipantLogoUrl = (type, id) =>
  `${CONTENT_URL.origin}/assets/participant/${type}/${id}.png`;
